import classNames from 'classnames';
import { Badge } from '@g17eco/ui-modern/components/ui/badge';
import { cn } from '@g17eco/ui-modern/lib/utils';
import { type CalculationNotice } from '../../types/emissions';
import { NOTICE_BADGE_CLASSES, NOTICE_COLORS } from './formatters';

interface ActivityNoticesPanelProps {
  notices?: CalculationNotice[];
}

export const ActivityNoticesPanel = ({ notices }: ActivityNoticesPanelProps) => {
  if (!notices || notices.length === 0) {
    return null;
  }

  return (
    <div>
      {notices.map((notice, index) => (
        <div
          key={`${notice.code}-${index}`}
          className={classNames(
            'border-start border-3 rounded-end p-3 mb-2 background-ThemeBgExtralight',
            `border-${NOTICE_COLORS[notice.type]}`,
          )}
        >
          <div className='d-flex align-items-center gap-2 mb-1'>
            <Badge className={cn(NOTICE_BADGE_CLASSES[notice.type], 'tw:uppercase tw:text-[0.65rem]')}>
              {notice.type}
            </Badge>
            <code className='text-ThemeTextLight'>{notice.code}</code>
          </div>
          <p className='mb-0'>{notice.message}</p>
        </div>
      ))}
    </div>
  );
};
